import { render, staticRenderFns } from "./DynamicTranslationsEditor.vue?vue&type=template&id=bb5ada5c&scoped=true&"
import script from "./DynamicTranslationsEditor.vue?vue&type=script&lang=js&"
export * from "./DynamicTranslationsEditor.vue?vue&type=script&lang=js&"
import style0 from "./DynamicTranslationsEditor.vue?vue&type=style&index=0&id=bb5ada5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5ada5c",
  null
  
)

export default component.exports